module.exports = __webpack_public_path__ + "img/allied-click.1622c1fa.png";